// import { useCallback } from 'react';
// import createContext from 'constate';
// import { formatWithCurrency } from '../utils/format';
// import { useQueryDigitalBillFeatureFlag, useQueryOfflineModeEnabled } from '../hooks/useFeatureFlagApi';
// import { LocationDtoV2 } from '../../generated-api';

// interface Props {
//   location: LocationDtoV2;
// }

// const [LocationContextProvider, useLocation] = createContext(({ location }: Props) => {
//   const formatCurrency = useCallback(
//     (amount: number) => (location ? formatWithCurrency(amount, location.currency) : ''),
//     [location]
//   );
//   const { data: digitalBillFeatureFlag } = useQueryDigitalBillFeatureFlag(location.locationId);
//   const { data: offlineModeFeatureFlag } = useQueryOfflineModeEnabled(location.locationId, true);

//   const isDigitalBillEnabled = !!digitalBillFeatureFlag?.waiterCanInitiate;

//   const featureFlags = {
//     digitalBillFeatureFlag: digitalBillFeatureFlag,
//     offlineModeFeatureFlag: offlineModeFeatureFlag,
//   };

//   const counterDeliveryMethod = location.deliveryMethods.find((deliveryMethod) => deliveryMethod.type === 'COUNTER');

//   return {
//     location,
//     formatCurrency,
//     isDigitalBillEnabled,
//     counterDeliveryMethod,
//     featureFlags,
//   };
// });

// export { LocationContextProvider, useLocation };

import { useCallback, useMemo } from 'react';
import createContext from 'constate';
import { formatWithCurrency } from '../utils/format';
import {
  useQueryDigitalBillFeatureFlag,
  useQueryFailedPaymentPromptFeatureFlag,
  useQueryOfflineModeEnabled,
} from '../hooks/useFeatureFlagApi';
import { LocationDtoV3 } from '../../generated-api';

interface Props {
  location: LocationDtoV3;
}

const [LocationContextProvider, useLocation] = createContext(({ location }: Props) => {
  const { data: digitalBillFeatureFlag } = useQueryDigitalBillFeatureFlag(location.id);
  const { data: offlineModeFeatureFlag } = useQueryOfflineModeEnabled(location.locationId);
  const { data: failedPaymentPromptFeatureFlag } = useQueryFailedPaymentPromptFeatureFlag(location.locationId);

  const isDigitalBillEnabled = !!digitalBillFeatureFlag?.waiterCanInitiate;

  const formatCurrency = useCallback(
    (amount: number) => (location ? formatWithCurrency(amount, location.currency) : ''),
    [location] // specific field
  );

  const counterDeliveryMethod = useMemo(() => {
    return location.deliveryMethods.find((d) => d.type === 'COUNTER');
  }, [location.deliveryMethods]);

  const featureFlags = useMemo(
    () => ({
      digitalBillFeatureFlag,
      offlineModeFeatureFlag,
      failedPaymentPromptFeatureFlag,
    }),
    [digitalBillFeatureFlag, offlineModeFeatureFlag, failedPaymentPromptFeatureFlag]
  );

  return useMemo(
    () => ({
      location,
      formatCurrency,
      isDigitalBillEnabled,
      counterDeliveryMethod,
      featureFlags,
    }),
    [location, formatCurrency, isDigitalBillEnabled, counterDeliveryMethod, featureFlags]
  );
});

export { LocationContextProvider, useLocation };
